import { useStencilActiveSlug } from './useStencilActiveSlug'
import { useStencilNavigation } from './useStencilNavigation'

export const useSetActiveSlug = useStencilActiveSlug

export const useNavigationContext = useStencilNavigation
